import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useLanguage } from "../context/LanguageContext";
import { usePageMeta } from "../utils/usePageMeta";

const AgreementPage = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();

    // Legal pages exist in Ukrainian only, so they get a canonical but no hreflang pair
    usePageMeta({
        title: "Акт прийому-передачі обладнання — SmarTOOL",
        description: "Акт прийому-передачі орендованого обладнання: додаток до договору оренди SmarTOOL.",
        canonical: "https://kh-tools.com/agreement",
        lang: "uk",
    });

    return (
        <div className="min-h-screen bg-gray-50">
            <Header
                title={t("agreement.headerTitle")}
                showBack
                onBack={() => navigate(-1)}
            />

            <div className="p-4 pb-8 animate-slide-in">
                {/* Title */}
                <div className="bg-white rounded-2xl shadow-sm p-5 mb-4">
                    <h1 className="text-base font-bold text-gray-900 text-center leading-snug">
                        {t("agreement.mainTitle")}
                    </h1>
                </div>

                {/* Section 1 */}
                <div className="bg-white rounded-2xl shadow-sm p-5 mb-4">
                    <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs flex-shrink-0">
                            1
                        </span>
                        {t("agreement.s1Title")}
                    </h2>
                    <div className="text-sm text-gray-600 leading-relaxed space-y-2 pl-8">
                        <p>
                            <span className="font-medium text-gray-700">1.1.</span>{" "}
                            {t("agreement.s1p1")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">1.2.</span>{" "}
                            {t("agreement.s1p2")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">1.3.</span>{" "}
                            {t("agreement.s1p3")}
                        </p>
                    </div>
                </div>

                {/* Section 2 */}
                <div className="bg-white rounded-2xl shadow-sm p-5 mb-4">
                    <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs flex-shrink-0">
                            2
                        </span>
                        {t("agreement.s2Title")}
                    </h2>
                    <div className="text-sm text-gray-600 leading-relaxed space-y-2 pl-8">
                        <p>
                            <span className="font-medium text-gray-700">2.1.</span>{" "}
                            {t("agreement.s2p1")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">2.2.</span>{" "}
                            {t("agreement.s2p2")}
                        </p>
                    </div>
                </div>

                {/* Section 3 */}
                <div className="bg-white rounded-2xl shadow-sm p-5 mb-4">
                    <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs flex-shrink-0">
                            3
                        </span>
                        {t("agreement.s3Title")}
                    </h2>
                    <div className="text-sm text-gray-600 leading-relaxed space-y-2 pl-8">
                        <p>
                            <span className="font-medium text-gray-700">3.1.</span>{" "}
                            {t("agreement.s3p1")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">3.2.</span>{" "}
                            {t("agreement.s3p2")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">3.3.</span>{" "}
                            {t("agreement.s3p3")}
                        </p>
                    </div>
                </div>

                {/* Section 4 */}
                <div className="bg-white rounded-2xl shadow-sm p-5 mb-4">
                    <h2 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs flex-shrink-0">
                            4
                        </span>
                        {t("agreement.s4Title")}
                    </h2>
                    <div className="text-sm text-gray-600 leading-relaxed space-y-2 pl-8">
                        <p>
                            <span className="font-medium text-gray-700">4.1.</span>{" "}
                            {t("agreement.s4p1")}
                        </p>
                        <p>
                            <span className="font-medium text-gray-700">4.2.</span>{" "}
                            {t("agreement.s4p2")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgreementPage;
